module.exports = __webpack_public_path__ + "static/media/gitea.23137649.svg";